import React, { useState, useEffect, useContext, useRef } from 'react';
import DisableDevtool from 'disable-devtool';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';

// Global flag to persist across component remounts
let globalHasLogged = false;

const DevToolsBlocker = () => {
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);
  const { user, token, API_URL, checkAuthStatus } = useContext(AuthContext);
  
  // Create a ref to store the LATEST auth state.
  // This solves the React closure trap where DisableDevtool captures the initial "null" user state!
  const authState = useRef({ user, token, API_URL, checkAuthStatus });
  
  useEffect(() => {
    authState.current = { user, token, API_URL, checkAuthStatus };
  }, [user, token, API_URL, checkAuthStatus]);

  useEffect(() => {
    // Only run this strict check in production
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    DisableDevtool({
      ondevtoolopen: async (type, next) => {
        setIsDevToolsOpen(true);
        
        const currentAuth = authState.current;
        
        // Log the violation to the backend if the user is logged in
        if (currentAuth.user && currentAuth.token && currentAuth.API_URL && !globalHasLogged) {
          globalHasLogged = true;
          try {
            const res = await axios.post(`${currentAuth.API_URL}/users/log-devtools-violation`, {}, {
              headers: { Authorization: `Bearer ${currentAuth.token}` }
            });
            
            // If the backend locked them out, instantly refresh their auth state
            if (res.data && res.data.isLocked) {
              await currentAuth.checkAuthStatus();
            }
          } catch (err) {
            console.error('Error logging DevTools violation:', err);
            // Allow logging again if it failed
            globalHasLogged = false;
          }
        }
        
        // By NOT calling next(), we prevent the library's default behavior 
        // (which is to close the window or redirect to a blank page).
        // Instead, our React state will render the custom message overlay!
      },
      // Disable the library's default context menu blocking (optional)
      disableMenu: true
    });
    
  }, []);

  if (!isDevToolsOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: '#fff',
      color: '#ff453a',
      zIndex: 9999999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      textAlign: 'center',
      fontFamily: 'sans-serif'
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Access Suspended</h1>
      <p style={{ fontSize: '1.2rem', color: '#333', marginBottom: '2rem', maxWidth: '600px' }}>
        Developer Tools or Inspector mode has been detected. For security and copyright protection, access to this portal is restricted while Developer Tools are active. Please close the panel to continue.
      </p>
      
      <button 
        onClick={() => setIsDevToolsOpen(false)}
        style={{
          padding: '12px 24px',
          fontSize: '1rem',
          backgroundColor: 'var(--primary-color, #007bff)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}
      >
        I understand, and will avoid accessing Developer Tools
      </button>
    </div>
  );
};

export default DevToolsBlocker;
